import { render, staticRenderFns } from "./InvoiceDocumentPreview.vue?vue&type=template&id=4c0fe968&scoped=true&"
import script from "./InvoiceDocumentPreview.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDocumentPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0fe968",
  null
  
)

export default component.exports